
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Plus } from "lucide-react";

interface EmptySermonPlansProps {
  onOpenWelcome: () => void;
}

export function EmptySermonPlans({ onOpenWelcome }: EmptySermonPlansProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-6">
        <p className="text-gray-500 mb-4">No sermon plans found</p>
        <Button onClick={onOpenWelcome}>
          <Plus className="mr-2 h-4 w-4" /> Create Your First Sermon Plan
        </Button>
      </CardContent>
    </Card>
  );
}
